import React from 'react';
import { environments } from 'environments/environments';
import SingleGallery from '../SingleGallery/SingleGallery';
import { byLatest } from 'libs/functions/order';
import './GalleryList.css';
import DTHead from 'assets/img/DT_head.png';


class GalleryList extends React.Component {
  state = {
    galleries: [] as any[],
    loading: true,
    error: false,
  }

  noMore = false;

  componentDidMount() {
    this.getGalleryList();
  }

  getGalleryList() {
    this.setState({ loading: true, error: false });
    const galNum = this.state.galleries.length;
    const params = `?t=galleries&count=6${galNum ? '&from=' + galNum : ''}`;
    const anticache = '&anticache=' + Date.now();
    fetch(environments.server + environments.backend + params + anticache)
      .then(res => {
        const galleries = this.state.galleries;
        try {
          return res.json();
        } catch {
          this.setState({ galleries, loading: false, error: true });
          return [];
        }
      })
      .then((res: any[]) => {
        const galleries = this.state.galleries;
        if (res && res.length) {
          const newGalleries = res.sort(byLatest);
          this.setState({ galleries: [...galleries, ...newGalleries], loading: false, error: false });
        } else {
          this.noMore = true;
          this.setState({ galleries, loading: false, error: true });
        }
        // console.log(res);
      });
  }

  render() {
    const renderGalleries = this.state.galleries.map((gallery, index) => <SingleGallery key={index} gallery={gallery} />)
    return (
      <div className="section gallery-list">
        {renderGalleries}
        {this.state.loading
          ? <p className='loading-info'><span className="loading loading-spinner"></span> Načítá se seznam fotogalerií...</p>
          : this.noMore
            ? null
            : <p className="load-more fake-link" onClick={() => this.getGalleryList()}>
              <img className="small-loading-head" src={DTHead} alt="+" /> &nbsp; Načíst další
            </p>
        }
        {this.state.error && !this.state.galleries.length
          ? <p className='loading-info'>Při načítání fotogalerií došlo k chybě, zkusit <span onClick={() => this.getGalleryList()}>ZNOVU</span>?</p>
          : null
        }
      </div>
    );
  }
}

export default GalleryList;